'use client';
import { useEffect, useMemo, useRef } from 'react';
import { useGetDrawResult } from '../entry.js';
/**
 * Hook to check all events on draw to see if any results have changed since the last check.
 *
 * @param drawNumber draw number to check results for
 * @param product product module engine to check results for
 * @returns An array of objects containing the team ('Home' or 'Away') and the event number for each event where the result has changed.
 */
export function useResultChanged(drawNumber, product) {
    const drawResultsData = useGetDrawResult({ product, drawNumber });
    const previousResultsRef = useRef(drawResultsData.data.type === 'FORECAST' ? drawResultsData.data.data.drawResults : []);
    const drawResults = useMemo(() => (drawResultsData.data.type === 'FORECAST' ? drawResultsData.data.data.drawResults : []), [drawResultsData.data]);
    useEffect(() => {
        previousResultsRef.current = drawResults;
    }, [drawResults]);
    const changedResults = useMemo(() => {
        const results = [];
        for (const eventResult of drawResults) {
            // eslint-disable-next-line react-hooks/refs
            const correspondingLastDrawEventResult = previousResultsRef.current.find((lastDrawEventResult) => eventResult.eventNumber === lastDrawEventResult.eventNumber);
            if (!correspondingLastDrawEventResult) {
                continue;
            }
            if (eventResult.result[0] !== correspondingLastDrawEventResult.result[0]) {
                results.push({
                    eventNumber: eventResult.eventNumber,
                    team: 'Home',
                });
            }
            if (eventResult.result[1] !== correspondingLastDrawEventResult.result[1]) {
                results.push({
                    eventNumber: eventResult.eventNumber,
                    team: 'Away',
                });
            }
        }
        return results;
    }, [drawResults, previousResultsRef]);
    return changedResults;
}
//# sourceMappingURL=useResultChanged.js.map